export default __webpack_public_path__ + "static/media/icon_book.e9a6f97b.svg";